export default __webpack_public_path__ + "static/media/o-projekcie-napis_2.884e1bcf.jpg";